<template>
  <h1 v-if="type === 'd1'" class="typography-display-3 md:typography-display-1">
    <slot />
  </h1>
  <h1 v-else-if="type === 'd2'" class="typography-display-3 md:typography-display-2">
    <slot />
  </h1>
  <h1 v-else-if="type === 'd3'" class="typography-headline-1 md:typography-display-3">
    <slot />
  </h1>
  <h1 v-else-if="type === 'h1'" class="typography-headline-1">
    <slot />
  </h1>
  <h2 v-else-if="type === 'h2'" class="typography-headline-2">
    <slot />
  </h2>
  <h3 v-else-if="type === 'h3'" class="typography-headline-5 md:typography-headline-3">
    <slot />
  </h3>
  <h4 v-else-if="type === 'h4'" class="typography-headline-4">
    <slot />
  </h4>
  <h5 v-else-if="type === 'h5'" class="typography-label-sm md:typography-headline-5">
    <slot />
  </h5>
  <h6 v-else-if="type === 'h6'" class="typography-text-xs md:typography-headline-6">
    <slot />
  </h6>
</template>

<script setup lang="ts">
import type { HeadingProps } from '~/components/ui/Heading/types';

defineProps<HeadingProps>();
</script>
